
import Component from '../../../assets/scripts/modules/component'
import insertScript from '../../../assets/scripts/utilities/insert-script'
import randomHash from '../../../assets/scripts/utilities/random-hash'

export default class VideoEmbedComponent extends Component {
  init () {
    this.container = this.element.querySelector('.video-embed__container')
    this.hitTarget = this.element.querySelector('.video-embed__hit-target')
    this.autoplay = this.element.classList.contains('video-embed--autoplay')
    this.videoId = this.element.getAttribute('data-video-id')
    this.startSeconds = this.element.getAttribute('data-start-time')

    if (!this.container || !this.hitTarget || !this.videoId) {
      return
    }

    this.iframeId = `youtube-iframe-${randomHash()}`
    this.player = null

    this.initVideo()
  }

  initVideo () {
    this.hitTarget.addEventListener('click', this.onHitTargetClick.bind(this))

    if (this.autoplay) {
      window.addEventListener('init-delayed-load', event => this.hitTarget.click(event))
    }
  }

  onHitTargetClick (event) {
    event.preventDefault()

    if (this.player) {
      this.player.playVideo()
    } else if (window.YT) {
      this.insertYouTubeContainer()
    } else {
      insertScript('youtube-api-script', '//www.youtube.com/iframe_api', this.insertYouTubeContainer.bind(this))
    }
  }

  insertYouTubeContainer () {
    const div = document.createElement('div')

    div.id = this.iframeId
    div.className = 'video-embed__iframe'

    this.hitTarget.parentNode.replaceChild(div, this.hitTarget)
    this.hitTarget = null

    const afterLoad = () => {
      this.player = new window.YT.Player(this.iframeId, {
        host: 'https://www.youtube-nocookie.com',
        width: 640,
        height: 360,
        videoId: this.videoId,
        startSeconds: this.startSeconds,
        playerVars: {
          autoplay: 1,
          hd: 1,
          showinfo: 0,
          modestbranding: 1,
          iv_load_policy: 3,
          rel: 0,
          origin: `${window.location.protocol}//${window.location.host}`
        },
        events: {
          onReady: () => {
            this.element.classList.add('video-embed--loaded')
            this.player.setPlaybackQuality('hd1080')
            if (this.startSeconds > 0) {
              this.player.seekTo(this.startSeconds)
            }

            if (this.element.getAttribute('data-autoplay') !== null) {
              this.player.playVideo()
            }
          }
        }
      })

      window.youtubeLoaded = true
    }

    if (!window.youtubeLoaded) {
      window.onYouTubeIframeAPIReady = afterLoad
    } else {
      afterLoad()
    }
  }
}

window.addEventListener('DOMContentLoaded', () => {
  for (const element of document.querySelectorAll('.video-embed')) {
    element.instance = element.instance || new VideoEmbedComponent(element)
  }
})
